export default __webpack_public_path__ + "static/media/nft7.3961e15a.png";